type EventProps = Record<string, string | number | boolean>;

function isOptedOut(): boolean {
  if (typeof navigator === 'undefined') return true;
  const dnt = navigator.doNotTrack === '1' || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true;
  return dnt;
}

export function track(event: string, props: EventProps = {}): void {
  if (typeof window === 'undefined' || isOptedOut()) return;
  const payload = JSON.stringify({ event, props });
  try {
    if ('sendBeacon' in navigator) {
      const blob = new Blob([payload], { type: 'application/json' });
      if (navigator.sendBeacon('/api/events', blob)) return;
    }
    void fetch('/api/events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
      credentials: 'omit',
    }).catch(() => undefined);
  } catch {
    // La medición nunca debe bloquear una compra o una partida.
  }
}
